export const environment = {
	production: false,
	api: 'https://dev-revealense-api.revealense.com/api/V1/'
};
